import Taro from '@tarojs/taro';

const useDidShow = (callback: () => any) => {
  try {
    Taro.useDidShow(callback);
  } catch (error) {
    // do nothing
  }
};

export default useDidShow;
